module.exports = __webpack_public_path__ + "img/secondarySlot.1e647811.png";